// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/MinusCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleTwoToneSvg
  }));
};

MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
export default React.forwardRef(MinusCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MinusCircleTwoTone.js
// module id = 1491
// module chunks = 0